import { assert_equal } from '@shared/asserts/utils_asserts';

export class ENUM__string_pattern {
  static readonly UUID = ['^((?:uuid:)?([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000))$', 'i'];
  static readonly OBJECT_ID = ['^((?:object_id:)?[0-9a-fA-F]{24})$', 'i'];
  static readonly HASH_SHA256 = ['^((?:sha256:)?[A-Fa-f0-9]{64})$', 'i'];
  static readonly EMOJI = ['^[\p{Emoji}\p{Extended_Pictographic}]+[\s]*', 'gu'];
  static readonly ANY = ['.*', ''];
}

export namespace ENUM_UTILS__string_pattern {
  export function to_regex(pattern_parts: string[]) {
    assert_equal(pattern_parts.length, 2);

    let [pattern, flags] = pattern_parts;

    return new RegExp(pattern, flags);
  }
}
